import React from "react";
import Chart from "react-apexcharts";
import {NpsData, NumberScaleData} from "../../../types/admin";
import {Col} from "react-bootstrap";
import {ADMIN_LANG} from "../../../settings";

type Props = {
    optionsData: NumberScaleData[];
    npsScale: NpsData | undefined;
}

const NumberScaleChart = ({ optionsData, npsScale }: Props) => {
    const series = [{
        data: optionsData.map(option => ({
            x: option.rating.toString(),
            y: option.selections,
            fillColor: npsScale
                ? option.rating <= 6
                    ? '#dc3545'
                    : option.rating <= 8
                        ? '#ffc107'
                        : '#28a745'
                : '#6c757d'
        }))
    }];

    const options: ApexCharts.ApexOptions = {
        chart: {
            type: 'bar',
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: true,
            },
        },
        dataLabels: {
            enabled: true,
            formatter: function (val: number, { dataPointIndex }: { dataPointIndex: number }) {
                const option = optionsData[dataPointIndex];
                return `${val} (${option.percentage})`;
            }
        },
        xaxis: {
            categories: optionsData.map(option => option.name ? `(${option.name}) ${option.rating}` : `${option.rating}`),
        },
        colors: optionsData.map(option =>
            npsScale
                ? option.rating <= 6
                    ? '#dc3545'
                    : option.rating <= 8
                        ? '#ffc107'
                        : '#28a745'
                : '#6c757d'
        ),
        tooltip: {
            y: {
                formatter: function (val: number, { dataPointIndex }: { dataPointIndex: number }) {
                    const option = optionsData[dataPointIndex];
                    return `${ADMIN_LANG.selections}: ${val}<br> ${ADMIN_LANG.percentage}: ${option.percentage}`;
                },
                title: {
                    formatter: () => ''
                }
            }
        }
    };

    function getNpsRatingColor(rating:number) {
        if (rating >= 50) return '#198754';
        if (rating >= 0) return '#ffc107';
        if (rating >= -50) return '#dc3545';
        return '#dc3545';
    }


    return (
        <Col xs={12} lg={6} className="mb-4 mb-lg-0">
            <div className='admin-card'>
                {npsScale && (
                    <div className='nps-score-card'>
                        {ADMIN_LANG.nps_rating}: <span className='badge fs-4 ms-2'
                                          style={{backgroundColor: getNpsRatingColor(npsScale.rating)}}>{npsScale.rating}</span>
                    </div>
                )}
                {optionsData.length > 0
                    ? <Chart options={options} series={series} type='bar' height={350}/>
                    : <h3>No data</h3>
                }
            </div>
        </Col>
    );
}

export default NumberScaleChart;